<template>
    <div class="sb-sug-container" :class="containerClass">
        <div class="title_container" v-if="inMore">
            <div class="title_mid">{{ label }}</div>
        </div>
        <div class="suggestion-content">
            <suggestion-mobile
                v-if="isMobileSize"
                v-bind="$attrs"
            />
            <suggestion-pc v-else v-bind="$attrs" />
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';
import Pc from './pc';
import Mobile from './mobile';
export default {
    name: 'Suggestion',
    props: {
        label: {
            type: String,
            default: ''
        }
    },
    components: {
        'suggestion-pc': Pc,
        'suggestion-mobile': Mobile
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        inMore() {
            return this.$attrs.inMore;
        },
        containerClass() {
            return classNames(this.$attrs.theme || 'standard');
        }
    }
};
</script>

<style lang="scss">
.sb-sug-container {
    width: 100%;

    .title_container {
        margin-bottom: 10px;
    }
    .suggestion-content {
        height: 40px;
    }
}
</style>
